<template>
  <v-card>
    <v-card-title>Font Color</v-card-title>
    <ColorSettings
      v-model="colors"
      :defaults="{
        color: '#000000',
      }"
      :excluded="['background', 'backgroundHover', 'colorHover']"
      @update:modelValue="handleUpdateColors"
    />
    <v-card-title>Typography Settings</v-card-title>
    <TypographySettings
      v-model="typography"
      :excluded="[
        'family',
        'textAlignment',
        'style',
        'decoration',
        'letterSpacing',
        'transform',
      ]"
      @update:modelValue="handleUpdateFontStyles"
      @fonts-loaded="handleFontsLoaded"
    />
  </v-card>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { ColorSettings, TypographySettings } from '@jazel/jazel-vuetify'
import { useProductSettingsStore } from '@/store/productSettings'

const productSettings = useProductSettingsStore()
const colors = ref({
  color: productSettings.typographySettings.markupTextColor,
} as any)
const typography = ref({
  fontSize: productSettings.typographySettings.markupFontSize,
  fontSizeUnit: productSettings.typographySettings.markupFontSizeUnit,
  lineHeight: productSettings.typographySettings.markupLineHeight,
  lineHeightUnit: productSettings.typographySettings.markupLineHeightUnit,
  fontWeight: productSettings.typographySettings.markupTextWeight,
} as any)

const handleUpdateColors = () => {
  console.log('COLOR', colors.value)
  productSettings.typographySettings.markupTextColor = colors.value.color
}

const handleUpdateFontStyles = () => {
  console.log('typography', typography.value)
  productSettings.typographySettings.markupFontSize =
    typography.value?.fontSize ?? '20'
  productSettings.typographySettings.markupFontSizeUnit =
    typography.value?.fontSizeUnit ?? 'px'

  productSettings.typographySettings.markupLineHeight =
    typography.value?.lineHeight ?? '1.25'
  productSettings.typographySettings.markupLineHeightUnit =
    typography.value?.lineHeightUnit ?? 'em'

  productSettings.typographySettings.markupTextWeight =
    typography.value?.fontWeight ?? 'normal'
}

const handleFontsLoaded = () => {
  productSettings.typographySettings.markupFontFamily = 'Roboto, sans-serif'
}
</script>
